const handledUnauthorizedErrors = new WeakSet<object>()

export const markHandledUnauthorizedError = (error: unknown): void => {
    if (error && typeof error === 'object') {
        handledUnauthorizedErrors.add(error)
    }
}

export const isHandledUnauthorizedError = (error: unknown): boolean =>
    Boolean(
        error &&
            typeof error === 'object' &&
            handledUnauthorizedErrors.has(error)
    )
